import { LegalLayout } from '../components/LegalLayout';

export const TermsOfService = () => {
    return (
        <LegalLayout title="Terms of Service" lastUpdated="January 24, 2026">
            <p className="intro-text">
                Welcome to Nostavia Health. By accessing our platform, using our AI health tools, or purchasing our membership and lab services, you agree to these Terms. These Terms constitute a binding legal agreement between you and Nostavia Health.
            </p>

            <section>
                <h2>1. Nature of Services</h2>
                <p>
                    Nostavia Health provides distinct services:
                </p>
                <ul>
                    <li><strong>Health Intelligence Platform:</strong> Digital tools for tracking health metrics, calculating biological age, and receiving AI-driven lifestyle recommendations.</li>
                    <li><strong>Lab Service Aggregation:</strong> We partner with accredited third-party laboratories (e.g., Redcliffe Labs) to facilitate home sample collection and diagnostic testing. Nostavia Health is not a laboratory and usually acts as a technology intermediary.</li>
                </ul>
            </section>

            <section>
                <h2>2. Medical Disclaimer</h2>
                <div style={{ backgroundColor: '#fff3cd', color: '#856404', padding: '1rem', borderRadius: '0.5rem', marginBottom: '1rem', border: '1px solid #ffeeba' }}>
                    <strong>CRITICAL:</strong> NOSTAVIA HEALTH DOES NOT PROVIDE MEDICAL ADVICE OR DIAGNOSIS.
                </div>
                <p>
                    Our "Biological Age," "Disease Risk Scores," and "Deep Scan" insights are estimates based on probabilistic AI models and statistical analysis. They are for informational and educational purposes only. They do not replace professional medical evaluation. Always consult a qualified physician for interpretation of lab results and before making significant health changes.
                </p>
            </section>

            <section>
                <h2>3. Membership, Billing & Cancellations</h2>
                <ul>
                    <li><strong>Memberships:</strong> Monthly memberships are billed in advance. You may cancel your membership at any time via your account settings. Content access remains through the end of your current billing cycle.</li>
                    <li><strong>One-Time Panels:</strong> Payments for "Review Only" or specific panels are one-time charges.</li>
                    <li><strong>Refunds:</strong>
                        <ul>
                            <li><strong>Membership Fees:</strong> Generally non-refundable except where required by law.</li>
                            <li><strong>Lab Tests:</strong> Refundable only if cancelled at least 24 hours prior to the scheduled home sample collection time. Once a phlebotomist has been dispatched or a sample collected, no refunds can be issued.</li>
                        </ul>
                    </li>
                </ul>
            </section>

            <section>
                <h2>4. User Responsibilities</h2>
                <p>
                    You agree to provide accurate health history and demographic information, as this data significantly affects the accuracy of our AI insights. You also agree to follow all pre-test instructions (e.g., fasting) to ensure lab result validity.
                </p>
            </section>

            <section>
                <h2>5. Intellectual Property</h2>
                <p>
                    All content, including the "Nostavia" brand, logos, "Deep Scan" algorithms, and Biological Age calculation methodologies, are the exclusive property of Nostavia Health. You are granted a limited license for personal use only.
                </p>
            </section>

            <section>
                <h2>6. Limitation of Liability</h2>
                <p>
                    Nostavia Health is not liable for errors in third-party lab results, delays in sample collection, or for decisions you make based on our informational insights. Our total liability for any claim shall not exceed the amount you paid to us in the past 12 months.
                </p>
            </section>

            <section>
                <h2>7. Changes to Terms</h2>
                <p>
                    We may update these Terms to reflect service intervals or regulatory changes. Continued use of our Platform following updates constitutes your acceptance.
                </p>
            </section>

            <section>
                <h2>8. Contact</h2>
                <p>
                    Legal inquiries: contact@nostaviahealth.com
                </p>
            </section>
        </LegalLayout>
    );
};
